import React from 'react';
import { Flame } from 'lucide-react';

interface NavbarProps {
  streakDays: number;
  onOpenSettings?: () => void;
  onTestPush?: () => void;
  haEnabled?: boolean;
}

export const Navbar: React.FC<NavbarProps> = ({
  streakDays,
}) => {
  return (
    <header 
      className="sticky top-0 z-40 w-full bg-white dark:bg-black border-b border-black/[0.06] dark:border-white/[0.08] px-4 pb-2.5 transition-colors duration-300 shadow-sm navbar-safe-top"
      style={{ paddingTop: 'calc(env(safe-area-inset-top) + 32px)' }}
    >
      <div className="max-w-xl mx-auto flex items-center justify-between">
        {/* Brand identity - Apple Fitness Liquid Glass Style com novo ícone */}
        <div className="flex items-center gap-2.5">
          <img 
            src="/icons/icon-192.png" 
            alt="Vida" 
            className="w-8 h-8 rounded-[9px] object-cover shadow-[0_2px_10px_rgba(48,214,251,0.3)] border border-white/20 shrink-0" 
            style={{ width: 32, height: 32 }}
          />
          <div>
            <span className="text-[17px] font-extrabold tracking-tight text-slate-900 dark:text-white block leading-none">
              Vida
            </span>
            <span className="text-[10px] font-semibold tracking-wider uppercase text-slate-500 dark:text-white/50 block mt-0.5">
              Recomp & Flow
            </span>
          </div>
        </div>

        {/* Right actions - Apenas a chama de ofensiva */}
        <div className="flex items-center gap-2">
          {/* Streak Flame Badge */}
          <div 
            title="Sequência de dias cumpridos"
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/[0.04] dark:bg-white/[0.08] border border-black/[0.06] dark:border-white/[0.08] text-[#FF9F0A] shadow-sm"
          >
            <Flame className="w-3.5 h-3.5 fill-[#FF9F0A] text-[#FF9F0A]" />
            <span className="text-xs tabular-nums font-bold tracking-tight">{streakDays}d</span>
          </div>
        </div>
      </div>
    </header>
  );
};
